import { Model, belongsTo, hasMany } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  company: belongsTo('roomba/company'),
  location: belongsTo('roomba/location'),
  building: belongsTo('roomba/building'),
  devices: hasMany('roomba/device'),

  name: attr('string'),
  calendarId: attr('string'),
  status: attr('object'),
  claimable: attr('boolean'),
  maskMeetingNames: attr('boolean'),
});
